module.exports = __webpack_public_path__ + "assets/safety.svg?631499d6aafb8285077434066b90d509";